import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-role-card',
  templateUrl: './role-card.component.html',
  styleUrls: ['./role-card.component.scss'],
  standalone: false,
})
export class RoleCardComponent {
  @Input() roleType: 'particulier' | 'prestataire' = 'particulier';
  @Input() isSelected: boolean = false;
  @Input() title: string = '';
  @Input() imageSrc: string = '';
  @Input() isGrey: boolean = false;
  @Output() roleClicked = new EventEmitter<string>();

  constructor() {}

  onRoleClick() {
    this.roleClicked.emit(this.roleType);
  }
} 